var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 22.8H16.908C17.4347 22.8001 17.9467 22.627 18.3652 22.3074C18.7837 21.9877 19.0855 21.5393 19.224 21.0312L21.516 12.6312C21.6131 12.2751 21.6267 11.9015 21.5559 11.5393C21.485 11.1771 21.3316 10.8362 21.1076 10.5429C20.8835 10.2497 20.5948 10.012 20.264 9.84849C19.9332 9.68496 19.5691 9.59992 19.2 9.6H11.4V5.184C11.4 3.0312 9.65282 1.284 7.50002 1.284C7.32464 1.28385 7.15246 1.33104 7.00166 1.42059C6.85086 1.51014 6.72703 1.63873 6.64322 1.7928L2.40002 9.6",
    stroke: "current",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpLine);
export default __webpack_public_path__ + "static/media/thumbs-up-line.db0f941a34b2633a75d24a277204e949.svg";
export { ForwardRef as ReactComponent };